import $ from 'jquery';
import aos from '../libs/aos';
import header_mobile from '../libs/header-mobile';
import hamburger from '../../../views/components/hamburger/hamburger';
import logo from '../../../views/components/logo/logo';
import block_input_codice from '../../../views/partials/blocks/block-input-codice/block-input-codice';
import block_primary from '../../../views/partials/blocks/block-primary/block-primary';
import block_secondary from '../../../views/partials/blocks/block-secondary/block-secondary';
import block_testo from '../../../views/partials/blocks/block-testo/block-testo';
import form from '../libs/form';
import modal_validate from '../libs/modal-validate';
import modal_update from '../libs/modal-update';

export default {
    init() {

    },

    finalize() {
        aos();
        logo();
        hamburger();
        block_input_codice();
        block_primary();
        block_secondary();
        block_testo();
        header_mobile();
        form();
        modal_validate();
        modal_update();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js